import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tariff-main__wrapper" }
const _hoisted_2 = { class: "tariff-main__header" }
const _hoisted_3 = {
  key: 0,
  class: "tariff-main__header-amount h3 normal color-white"
}
const _hoisted_4 = { class: "tariff-main__header-amount__number" }
const _hoisted_5 = { class: "tariff-main__header-amount__number" }
const _hoisted_6 = {
  key: 0,
  class: "tariff-main__header-amount__number --old"
}
const _hoisted_7 = {
  key: 1,
  class: "tariff-main__header-description caption-small color-text-addons"
}
const _hoisted_8 = {
  key: 2,
  class: "tariff-main__header-description caption-medium color-grey-light"
}
const _hoisted_9 = { class: "tariff-main__options" }
const _hoisted_10 = {
  key: 0,
  class: "tariff-main__next-date color-white caption-small"
}

import { formatAmountInput } from "@/utils/format";
import { computed } from "vue";
import TariffMainOption from "@/components/tariff/TariffMainOption.vue";
import { PropType } from "@vue/runtime-core";
import { TariffOptionStruct } from "@/struct/TariffStruct";
import { useStore } from "vuex";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'TariffMain',
  props: {
  amount: {
    type: Number,
    default: 0,
  },
  oldAmount: {
    type: Number,
    default: 0,
  },
  discount: {
    type: Number,
    default: 0,
  },
  discountName: {
    type: String,
    default: "",
  },
  nextDate: {
    type: String,
    default: "",
  },
  options: {
    type: Array as PropType<TariffOptionStruct[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const mainTariff = computed(() => store.getters["tariff/mainTariff"]);
const { t } = useI18n();

const isBlocked = computed(() => {
  return props.options.findIndex((item) => item.value !== 0) === -1;
});

const classes = computed(() => {
  return [isBlocked.value ? "--blocked" : ""];
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tariff-main", classes.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "tariff" }, {
          default: _withCtx(() => [
            _createVNode(BaseFigureForIcon, {
              class: "tariff-main__header-more",
              icon: "more",
              color: isBlocked.value ? 'secondary' : 'white-opacity-40',
              size: "small",
              "is-button": ""
            }, null, 8, ["color"])
          ]),
          _: 1
        }),
        _createElementVNode("p", {
          class: _normalizeClass(["tariff-main__header-title h3", { 'color-white': !isBlocked.value }])
        }, _toDisplayString(mainTariff.value?.title), 3),
        (!isBlocked.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!isBlocked.value && __props.discount === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatAmountInput)(__props.oldAmount)) + " ₽ ", 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.perMonth")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (!isBlocked.value && __props.discount)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatAmountInput)(__props.amount)) + " ₽ ", 1),
                    (_unref(formatAmountInput)(__props.oldAmount).length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "  " + _toDisplayString(_unref(formatAmountInput)(__props.oldAmount)) + " ₽ ", 1))
                      : _createCommentVNode("", true),
                    _cache[0] || (_cache[0] = _createElementVNode("span", null, "   ", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.perMonth")), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!isBlocked.value && __props.discount)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.discountName), 1))
          : (isBlocked.value && !__props.discount)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(t)("tariff.main.unavailableLine1")), 1),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(t)("tariff.main.unavailableLine2")), 1)
              ]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
          return (_openBlock(), _createBlock(TariffMainOption, {
            key: item.id,
            option: item
          }, null, 8, ["option"]))
        }), 128))
      ]),
      (!isBlocked.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("tariff.main.nextCharge", { date: __props.nextDate })), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})